export const LOCALSTORAGE_TOKEN = "Scalance-crm-token";
export const LOCALSTORAGE_THEME = "Scalance-crm-theme";
